interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

const topics: MenuItem[] = [
    { url: "/class-five/mathematics/numbers", title: "Numbers" },
    { url: "/class-five/mathematics/numbers", title: "Roman Numerals" },
    { url: "/class-five/mathematics/numbers", title: "Addition & Subtraction" },
    { url: "/class-five/mathematics/numbers", title: "Multiplication & Division" },
    { url: "/class-five/mathematics/numbers", title: "Factors & Multiples" },
    { url: "/class-five/mathematics/numbers", title: "Fractions" },
    { url: "/class-five/mathematics/numbers", title: "Decimals" },
    { url: "/class-five/mathematics/numbers", title: "Introduction to Negetive Numbers" },
    { url: "/class-five/mathematics/numbers", title: "Geometry" },
    { url: "/class-five/mathematics/numbers", title: "Perimeter & Area" },
    { url: "/class-five/mathematics/numbers", title: "Metric System" },
    { url: "/class-five/mathematics/numbers", title: "Time & Money" },
    { url: "/class-five/mathematics/numbers", title: "Introduction to Percentage" },
    { url: "/class-five/mathematics/numbers", title: "Data Handling" },
    { url: "/class-five/mathematics/numbers", title: "Patterns" },
];


export default topics;